import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemActionImportationClass } from '../../../../../core/services/menu/menu-item-action-importation.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuItemActionTelechargementClass } from '../../../../../core/services/menu/menu-item-action-telechargement.service';
import { IMenuItemClass } from '../../../../../core/services/menu/menu-item.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IFilterDate } from 'angular';

interface IPageGS2005 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
    menuItemImage: any;
}
/* @ngInject */
export default function Gs2005Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemActionImportation: IMenuItemActionImportationClass,
    Menu: IMenuClass,
    MenuItem: IMenuItemClass,
    $stateParams: IStateParamsService,
    gs2005Route: IRoute,
    dateFilter: IFilterDate,
    $state: IStateService,
    MenuItemEcran: IMenuItemEcranClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemActionTelechargement: IMenuItemActionTelechargementClass,
) {

    const vm: IPageGS2005 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    vm.menuItemImage = new MenuItemActionImportation(
        'LBL_AJOUT_DOC',
        'BOUPJB',
        (rowData: any) => ({ id: vm.valeursEcran.pjbcleint_cle }),
        {
            formulaireConfirmationAction: {
                lblTitre: 'LBL_AJOUT_DOC',
                formulaire: new Formulaire([
                    new FormulaireItem('usrnom', {
                        readonly: true,
                        default: vm.valeursEcran.usrnom
                    }),
                    new FormulaireItem('datcrepjb', { default: dateFilter(new Date(), 'yyyy-MM-dd') }),
                    new FormulaireItem('pjbdsc', { largeur: 66 }),
                    new FormulaireItem('tpicleint'),
                    new FormulaireItem('pjbprvcle', {
                        hidden: true,
                        default: $stateParams.pjbprvcle
                    }),
                    new FormulaireItem('pjbcleintref', {
                        hidden: true,
                        default: $stateParams.pjbcleintref
                    }),

                ])
            },
            typesFichiers: ['.pdf', '.csv', '.txt'],
            successAction: () => vm.multiOccurrence.fetchDataList(),
            icon: 'add_circle',
            iconColor: 'red'
        }
    );

    vm.multiOccurrenceOptions = {
        actionsNouveaux: new Menu([
            vm.menuItemImage
        ]),
        colonnesVisibles: [
            { nom: 'usrnom', largeur: 180 },
            { nom: 'datecrepjb', largeur: 90 },
            {
                nom: 'pjbdsc', largeur: 157, menu: [
                    new MenuItemActionTelechargement(
                        'LBL_TELECHARGER',
                        'BOUPDF',
                        () => ({}),
                        {
                            iconButton: true,
                            icon: 'attach_file'
                        }
                    )]
            },
            { nom: 'ptidsc', largeur: 157 }
        ], colonnesCachees: ['pjbcleintref'], formulaire: new Formulaire([
            new FormulaireItem('pjbdsc', {
                largeur: 33
            }),
            new FormulaireItem('ptidsc', {
                readonly: true,
                largeur: 33
            })
        ]),
    };
}
